import React, {Fragment, useRef} from "react";
import { Link , NavLink} from "react-router-dom";

import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/pagination";


import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper";
import { Pagination } from "swiper";
import clientconfigwebapp from "../../../clientconfigwebapp";

const Home_Section_B = (props) => {
    return (


        <Fragment>


            <style jsx>{`

               
                    .mySwiper-secb .swiper-button-next {
                    background-color: white;
                    width: 47px;
                    height: 47px;
                    border-radius: 100%;
                    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
                    }
                    .mySwiper-secb .swiper-button-prev {
                    background-color: white;
                    width: 47px;
                    height: 47px;
                    border-radius: 100%;
                    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
                    }
                    .mySwiper-secb .swiper-button-next::after,.mySwiper-secb .swiper-button-prev::after {
                    font-size: 22px !important;
                    }

                
                

                .info-home-container {
                    margin-top: 68px;
                    margin-bottom: 68px;
                    background-color: #fff;
                }

                .swiper-home-info:nth-child(even) {
                    margin-top: 3rem;
                }
                .swiper-home-info{
                    padding-top: 20px;
                    padding-bottom: 20px;
                }

                .info-home-item {
                    position: relative;
                    cursor: pointer;
                }

                .info-home-bg {
                    position: absolute;
                    z-index: 1;

                    transform: rotate(-4deg);
                    flex-shrink: 0;
                    border-radius: 16px;
                }

                .info-home-bg--primary {
                    background: #ff9828;
                }

                .info-home-bg, .info-home-content {
                    width: 96%;
                    height: 101%;
                }

                .info-home-content {
                    transition: all 150ms linear;
                    position: relative;
                    z-index: 2;
                    flex-shrink: 0;
                    border-radius: 16px;
                    background: #fff;
                    box-shadow: 0px 0px 4px 4px rgba(168, 168, 168, 0.25);
                    overflow: hidden;
                    padding: 1rem;
                    gap: 10px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                }

                .info-home-icon {
                    width: 78px;
                    height: 78px;
                    flex-shrink: 0;
                    border-radius: 16px;
                    background: #ff9828;
                    box-shadow: 0px 0px 4px 4px rgba(168, 168, 168, 0.25);
                    display: flex;
                    align-items: center;
                    flex-direction: row;
                    justify-content: center;
                }

                .info-home-title {
                    color: #000;
                    font-family: iran !important;
                    font-size:16px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 1.6;
                }

                .info-home-subtitle {
                    color: #646464;
                    text-align: center;
                    font-family: iran;
                    font-size: 11px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 1.6;
                }

                .info-home-item:hover {
                    transition: all 300ms;
                }

                .info-home-item:hover .info-home-bg--primary {
                    background: #fff;
                    box-shadow: 0px 0px 4px 4px rgba(255, 214, 169, 0.65);
                }

                .info-home-item:hover .info-home-content {
                    background: #ff9828;
                }

                .info-home-item:hover .info-home-icon {
                    background: #ffac51;
                    box-shadow: none;
                }

                .info-home-item:hover .info-home-title {
                    color: #fff;
                }

                .info-home-item:hover .info-home-subtitle {
                    color: #fff;
                }

                .slider-component {
                    width: 100% !important;
                }


            `}</style>



            <div className="info-home-container">
                <div className="info-home-section">


                    <Swiper
                        dir="rtl"
                        spaceBetween={25}
                        slidesPerView={5}
                        loop={true}
                        navigation={true}
                        draggable={true}
                        modules={[Navigation]}
                        className="mySwiper slider-component mySwiper-secb"
                        centeredSlides={true}
                        breakpoints={{
                            1024: {
                                slidesPerView: 4,
                                spaceBetween: 18,
                            },
                            1400: {
                                slidesPerView: 5,
                                spaceBetween: 18,
                            },
                            800: {
                                slidesPerView: 5,
                                spaceBetween: 18,
                            },
                            768: {
                                slidesPerView: 4,
                                spaceBetween: 18,
                            },
                            300: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },

                        }}
                    >


                        <SwiperSlide className=" slide-container swiper-home-info">
                            <NavLink reloadDocument={true} to={"/panel/product-registration"} className="info-home-item">
                                <div className="info-home-bg info-home-bg--primary"></div>
                                <div className="info-home-content">
                                    <div className="info-home-icon">
                                        <img src={String(clientconfigwebapp.webappurl) + "images/assets/svgs/ads.svg"} alt=""/>
                                    </div>
                                    <div className="info-home-title">درج آگهی</div>
                                    <div className="info-home-subtitle">
                                        با درج آگهی رایگان در بازارانو، خرید عمده خود را به صدها خریدار هدفمند معرفی کنید و فروش‌تان را افزایش دهید
                                    </div>
                                </div>
                            </NavLink>
                        </SwiperSlide>

                        <SwiperSlide className=" slide-container swiper-home-info">
                            <NavLink to={"/about-us"} className="info-home-item">
                                <div className="info-home-bg info-home-bg--primary"></div>
                                <div className="info-home-content">
                                    <div className="info-home-icon">
                                        <img src={ String(clientconfigwebapp.webappurl) + "images/assets/svgs/question.svg"} alt=""/>
                                    </div>
                                    <div className="info-home-title">بازارنو چیست</div>
                                    <div className="info-home-subtitle">
                                        بازارنو پلتفرمی آنلاین برای ارتباط مستقیم خریداران و فروشندگان عمده، از تأمین تا تحویل محصولات عمده، بدون واسطه است.
                                    </div>
                                </div>
                            </NavLink>
                        </SwiperSlide>


                        <SwiperSlide className=" slide-container swiper-home-info">
                            <NavLink to={"/services"} className="info-home-item">
                                <div className="info-home-bg info-home-bg--primary"></div>
                                <div className="info-home-content">
                                    <div className="info-home-icon">
                                        <img src={String(clientconfigwebapp.webappurl) + "images/assets/svgs/services.svg"} alt=""/>
                                    </div>
                                    <div className="info-home-title">خدمات بازارنو</div>
                                    <div className="info-home-subtitle">
                                        ما در بازارانو، با ارائه خدمات کامل از تأمین تا تحویل، به شما در خرید عمده محصولات با کیفیت کمک می‌کنیم.
                                    </div>
                                </div>
                            </NavLink>
                        </SwiperSlide>


                        <SwiperSlide className=" slide-container swiper-home-info">
                            <NavLink reloadDocument={true} to={"/contact-us"} className="info-home-item">
                                <div className="info-home-bg info-home-bg--primary"></div>
                                <div className="info-home-content">
                                    <div className="info-home-icon">
                                        <img src={String(clientconfigwebapp.webappurl) + "images/assets/svgs/support.svg"} alt=""/>
                                    </div>
                                    <div className="info-home-title">تماس با ما</div>
                                    <div className="info-home-subtitle">
                                        برای خرید عمده محصولات با کیفیت, از تأمین تا تحویل مستقیم با تیم بازارانو تماس بگیرید!
                                    </div>
                                </div>
                            </NavLink>
                        </SwiperSlide>



                    </Swiper>


                </div>
            </div>


        </Fragment>
    );
}

export default Home_Section_B;